import { CarsRequestData } from '../../types/car';

export const generateCarFormData = (): CarsRequestData => {
  return {
    carCategoryId: 1,
    carNo: '',
    maxWeight: null,
    maxVolume: null,
    qualificationIds: [],
    driverLicenseId: 1,
    unavailableStartDate: '',
    unavailableEndDate: '',
  };
};
